<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <van-form @submit="handlerSubmit" @failed="handleFailed">
      <van-field
        required
        name="radio"
        label="本级少工委主任"
        class="radioFlex"
        :rules="[{ required: true, message: '请选择本级少工委主任' }]"
      >
        <template #input>
          <van-radio-group
            v-model="levelSGWDirector"
            direction="horizontal"
            v-for="item in levelSGWDirectorList"
            v-bind:key="item.key"
            @change="radioChange($event, 'levelSGWDirector', clearSGWDirector)"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <template v-if="levelSGWDirector && levelSGWDirector <= 2">
        <van-field
          required
          v-model="levelSGWDirectorName"
          clearable
          label="本级少工委主任姓名"
          placeholder="请填写本级少工委主任姓名"
          :rules="[{ required: true, message: '请填写本级少工委主任姓名' }]"
        />
        <van-field
          required
          name="radio"
          label="本级少工委主任身份"
          :rules="[{ required: true, message: '本级少工委主任身份' }]"
        >
          <template #input>
            <van-radio-group
              v-model="levelSGWDirectorJob"
              direction="horizontal"
              v-for="item in levelJobList"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-if="levelSGWDirectorJob"
          required
          v-model="levelSGWDirectorJobOther"
          clearable
          label="本级少工委主任职务"
          placeholder="本级少工委主任职务"
          :rules="[{ required: true, message: '本级少工委主任职务' }]"
        />
      </template>
      <template v-if="levelSGWDirector == 2">
        <van-field
          required
          v-model="levelSGWDirectorName2"
          clearable
          label="本级少工委主任姓名"
          placeholder="请填写本级少工委主任姓名"
          :rules="[{ required: true, message: '请填写本级少工委主任姓名' }]"
        />
        <van-field
          required
          name="radio"
          label="本级少工委主任身份"
          :rules="[{ required: true, message: '请选择本级少工委主任身份' }]"
        >
          <template #input>
            <van-radio-group
              v-model="levelSGWDirectorJob2"
              direction="horizontal"
              v-for="item in levelJobList"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="levelSGWDirectorJob2"
          required
          v-model="levelSGWDirectorJobOther2"
          clearable
          label="本级少工委主任职务"
          placeholder="本级少工委主任职务"
          :rules="[{ required: true, message: '本级少工委主任职务' }]"
        />
      </template>
      <datetime-picker
        :value="sdhsj"
        title="本届少代会召开时间"
        type="year-month"
        :callback="(val) => handlerSelect('sdhsj', val)"
        :isRequired="sdhsjFlag"
      />
      <van-field
        v-model="levelOutsideCounselorsNum"
        clearable
        type="digit"
        label="本级校外辅导员资源库人数"
        placeholder="请填写本级校外辅导员资源库人数"
      />

      <van-field
        required
        name="radio"
        label="是否配备总辅导员"
        class="radioFlex"
        :rules="[
          {
            required: true,
            message: '请选择是否配备总辅导员',
          },
        ]"
      >
        <template #input>
          <van-radio-group
            v-model="levelCounselors"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
            @change="radioChange($event, 'levelCounselors', clearCounselors)"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <template v-if="levelCounselors == 1">
        <van-field
          required
          v-model="name"
          clearable
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          required
          name="radio"
          label="性别"
          class="radioFlex"
          :rules="[{ required: true, message: '请选择性别' }]"
        >
          <template #input>
            <van-radio-group
              v-model="sex"
              direction="horizontal"
              v-for="item in sexs"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <datetime-picker
          :value="birthday"
          title="出生日期"
          type="year-month"
          :callback="(val) => handlerSelect('birthday', val)"
          :isRequired="birthdayFlag"
        />
        <datetime-picker
          :value="employmentTime"
          title="担任总辅导员时间"
          :maxDate="new Date()"
          :callback="(val) => handlerSelect('employmentTime', val)"
          :isRequired="employmentTimeFlag"
        />

        <van-field
          required
          name="radio"
          label="学历"
          :rules="[{ required: true, message: '请选择学历' }]"
        >
          <template #input>
            <van-radio-group v-model="edu" v-for="item in eduList" v-bind:key="item.key">
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          required
          name="radio"
          label="政治面貌"
          :rules="[{ required: true, message: '请选择政治面貌' }]"
        >
          <template #input>
            <van-radio-group
              v-model="zzmm"
              v-for="item in zzmmList"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          required
          v-model="tel"
          clearable
          label="手机号"
          maxlength="11"
          placeholder="请输入手机号"
          :rules="[
            { required: true, message: '请输入手机号' },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: '手机号格式错误',
            },
          ]"
        />

        <van-field
          required
          name="radio"
          label="编制所在单位"
          :rules="[{ required: true, message: '请选择编制所在单位' }]"
        >
          <template #input>
            <van-radio-group
              v-model="company"
              v-for="item in companyList"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-if="company == 7"
          required
          v-model="companyOther"
          clearable
          label="其他编制"
          placeholder="请输入编制所在单位"
          :rules="[{ required: true, message: '请输入编制所在单位' }]"
        />
        <van-field
          required
          name="radio"
          label="行政级别"
          :rules="[{ required: true, message: '请选择行政级别' }]"
        >
          <template #input>
            <van-radio-group
              v-model="administrationLevel"
              v-for="item in administrationList"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          required
          name="radio"
          label="岗位类型"
          :rules="[{ required: true, message: '请选择岗位类型' }]"
        >
          <template #input>
            <van-radio-group
              v-model="postType"
              v-for="item in postTypeList"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </template>
      <!--登录按钮-->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit" class="btn btn_dl">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { reactive, toRefs, watch, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import datetimePicker from "@/components/DatePicker";
import headers from "@/components/Header";
import {
  postTypeList,
  companyList,
  yORn,
  levelJobList,
  sexs,
  eduList,
  zzmmList,
  administrationList,
  levelSGWDirectorList,
} from "@/common/js/field";
import { Dialog } from "vant";
import { addForm, getsubmitData, editForm } from "@/service/form";
import { getKey, encrypt, rsaUtil, serverPublicKey, radioChange } from "@/common/js";
export default {
  name: "addForm2",
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let genKeyPair = rsaUtil.genKeyPair();
    window.jsPublicKey = genKeyPair.publicKey;
    window.jsPrivateKey = genKeyPair.privateKey;

    const state = reactive({
      levelSGWDirector: null,
      levelSGWDirectorName: null,
      levelSGWDirectorJob: null,
      levelSGWDirectorJobOther: null,
      levelSGWDirectorName2: null,
      levelSGWDirectorJob2: null,
      levelSGWDirectorJobOther2: null,
      sdhsj: null,
      sdhsjFlag: false,
      levelOutsideCounselorsNum: 0,
      levelCounselors: null,
      name: null,
      sex: null,
      birthday: null,
      birthdayFlag: false,
      employmentTime: null, //担任辅导员时间
      employmentTimeFlag: false,
      edu: null,
      zzmm: null,
      tel: null,
      company: null,
      administrationLevel: null,
      postType: null,
      companyOther: null,
    });
    const whiteList = ["birthdayFlag", "sdhsjFlag", "employmentTimeFlag"];

    watch(
      () => [state.levelOutsideCounselorsNum],
      () => {
        formatNumber("levelOutsideCounselorsNum");
      }
    );
    onMounted(async () => {
      const { type } = route.query;
      if (type == 1) {
        getInfo();
      }
    });
    const getInfo = async () => {
      const { id } = route.query;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;
      if (code == 10000 && data) {
        const newObj = {};
        for (const i of data.list) {
          let val = i.value;
          if (i.fieldCode == "birthday" || i.fieldCode == "sdhsj" || i.fieldCode == "employmentTime") {
            val = val * 1000;
          }
          newObj[i.fieldCode] = val;
        }
        console.log("data", newObj);

        //   赋值
        Object.assign(state, newObj);
      }
    };
    const formatNumber = (item) => {
      state[item] = Number(state[item]);
    };

    // 选择字段回调赋值
    const handlerSelect = (key, value) => {
      console.log("-value", value);
      state[key] = value;
      if (key == "birthday") {
        state.birthdayFlag = false;
      }
      if (key == "sdhsj") {
        state.sdhsjFlag = false;
      }
      if (key == "employmentTime") {
        state.employmentTimeFlag = false;
      }
    };
    const handleFailed = () => {
      console.log("handleFailed");
      Dialog.alert({
        message: "请填写所有必填信息* ~",
      }).then(() => {
        console.log("--33--");
      });
    };
    const handlerSubmit = () => {
      const { sdhsj, birthday, levelCounselors, employmentTime } = state;
      if (!sdhsj) {
        state.sdhsjFlag = true;
        return false;
      }

      if (levelCounselors == 1) {
        if (!birthday) {
          state.birthdayFlag = true;
          return false;
        }
        if (!employmentTime) {
          state.employmentTimeFlag = true;
          return false;
        }
      }

      Dialog.confirm({
        title: "提示",
        message: "你确定要提交吗？",
      })
        .then(() => {
          proxy.$showLoading();
          add(state);
        })
        .catch(() => {
          // on cancel
        });
    };
    const add = async (values) => {
      const { type } = route.query;
      let arr = [];
      let data = {
        formId: 3,
        list: [],
      };
      let fn = addForm;
      if (type == 1) {
        const { id } = route.query;
        data.id = id;
        fn = editForm;
      }
      for (let i in values) {
        let val = values[i];
        if ((i == "birthday" || i == "sdhsj" || i == "employmentTime" ) && values[i] && values[i].toString().length > 10) {
          val = val / 1000;
          values[i] = val;
        }
        // if (i == "sdhsj" && values[i] && values[i].toString().length > 10) {
        //   val = val / 1000;
        //   values[i] = val;
        // }
      }

      for (const item in values) {
        let obj = {
          fieldCode: item,
          value: values[item],
        };
        if (whiteList.indexOf(item) !== -1) {
          continue;
        }
        if (values[item] || values[item] == 0) {
          arr.push(obj);
        }
      }
      data.list = arr;
      console.log("data", data);

      //随机获取AES的key
      let aesKey = getKey().toLowerCase();
      let param = {
        encryptData: encrypt(data, aesKey), //AES加密后的数据
        encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
        // publicKey: window.jsPublicKey //前端公钥
      };
      try {
        const res = await fn(param);
        if (res.code === 10000) {
          proxy.$closeLoading();
          Dialog.alert({
            message: "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~",
          }).then(() => {
            goTo();
          });
        } else {
          proxy.$closeLoading();
        }
      } catch (error) {
        proxy.$closeLoading();
      }
    };
    const goTo = () => {
      // console.log("goTo");
      // const { id } = route.query;
      // if (id) {
      //   router.push({ path: "/info/detail/form2", query: { id } });
      // }
      router.push({ path: "/info/wtg" });
    };

    const goBack = () => {
      router.go(-1);
    };

    // 切换状态时清空内容
    const clearSGWDirector = (val) => {
      if (val == 1) {
        state.levelSGWDirectorName2 = null;
        state.levelSGWDirectorJob2 = null;
        state.levelSGWDirectorJobOther2 = null;
      }
    };
    const clearCounselors = (val) => {
      if (val == 2) {
        state.name = null;
        state.sex = null;
        state.birthday = null;
        state.employmentTime = null;
        state.edu = null;
        state.zzmm = null;
        state.tel = null;
        state.company = null;
        state.administrationLevel = null;
        state.postType = null;
      }
    };

    return {
      ...toRefs(state),
      yORn,
      sexs,
      eduList,
      zzmmList,
      levelJobList,
      companyList,
      postTypeList,
      administrationList,
      levelSGWDirectorList,
      handlerSelect,
      handlerSubmit,
      goBack,
      radioChange,
      clearSGWDirector,
      clearCounselors,
      handleFailed,
    };
  },
  components: {
    datetimePicker,
    headers,
  },
};
</script>
<style lang="less" scoped>
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}
:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-radio-group) {
  padding: 0.168rem 0;
}
</style>
